export default `
  mutation addUsersToSubscription($users: [StripeUserInput]!) {
    addUsersToSubscription(users: $users) {
      success
      message
      emails
      clientSecret
      subscriptionId
      newUsersExceedSeats
      newQuantity
    }
  }
`
